import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

import { Button, Typography } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { setSelectedLineItemFilters } from '../../../../actions/households/households.actions'

import { DeletableChip } from '../../../Misc/DeletableChip'
import { cloneDeep } from 'lodash'

const useStyles = makeStyles((theme) => ({
	wrapper: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap'
	}
}))

export const SelectedFilters = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()

	const selectedFilters = useSelector((state) => state.specific.households.selectedLineItemFilters)
	const filters = useSelector((state) => state.specific.households.lineItemFilters)

	return (
		<div className={classes.wrapper}>
			{Object.keys(selectedFilters)
				.filter((f) =>
					Array.isArray(selectedFilters[f]) && selectedFilters[f].length
						? true
						: typeof selectedFilters[f] === 'boolean'
						? selectedFilters[f]
						: false
				)
				.map((f) => {
					let currentFilter = filters[f]
					let currentSelectedFilter = selectedFilters[f]

					if (Array.isArray(currentFilter) && Array.isArray(currentSelectedFilter)) {
						let items = currentFilter.filter((cf) => currentSelectedFilter.includes(cf.value))

						return (
							<div className={classes.wrapper}>
								{items.map((i) => (
									<DeletableChip
										key={i.value}
										label={i.label}
										{...{
											onDelete: () => {
												let updates = cloneDeep(selectedFilters)

												updates[f] = updates[f].filter((s) => s !== i.value)

												dispatch(setSelectedLineItemFilters(updates))
											}
										}}
									/>
								))}
							</div>
						)
					} else if (currentSelectedFilter) {
						return (
							<DeletableChip
								key={currentFilter.value}
								label={currentFilter.label}
								{...{
									onDelete: () => {
										let updates = cloneDeep(selectedFilters)

										updates[f] =
											typeof currentSelectedFilter === 'boolean'
												? !updates[f]
												: updates[f].filter((s) => s !== currentFilter.value)

										dispatch(setSelectedLineItemFilters(updates))
									}
								}}
							/>
						)
					} else {
						return null
					}
				})}
			<Button
				variant="text"
				style={{
					borderRadius: 6,
					margin: '4px 0px'
				}}
				onClick={() => {
					let updates = cloneDeep(selectedFilters)

					for (const key in updates) {
						if (updates.hasOwnProperty(key)) {
							if (Array.isArray(updates[key])) updates[key] = []
							else updates[key] = false
						}
					}

					dispatch(setSelectedLineItemFilters(updates))
				}}>
				<Typography variant="overline" style={{ color: '#6B4AD6', lineHeight: 1 }}>
					Clear All
				</Typography>
			</Button>
		</div>
	)
}
